import FluxUtils from 'flux/utils';

import AboutActions from 'sharedreact/actions/AboutActions';
import AboutDialog from 'sharedreact/components/AboutDialog';
import AboutStore from 'sharedreact/stores/AboutStore';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import asFunctional from 'sharedreact/components/asFunctional';

type State = ConstructorParameters<typeof AboutDialog>[0];

function getStores () {
  return [
    AboutStore,
    SettingsStore
  ];
}

function calculateState (prevState?: State): State {
  return {
    title: AboutStore.getVersionInfo(),
    show: AboutStore.getShow(),
    language: SettingsStore.getLanguage(),
    legalNotices: AboutStore.getLegalNotices(),

    onClose: AboutActions.hideAbout
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(AboutDialog),
  getStores,
  calculateState
);
